import {BODIES}          from '../constants/bodies';
import {BODIES_BY_TYPE}  from '../constants/bodies-by-type';
import {DRIVERS_BY_SIZE} from '../constants/drivers-by-size';
import {GLIDERS}         from '../constants/gliders';
import {STATISTICS}      from '../constants/statistics';
import {TIRES}           from '../constants/tires';

export const buildKarts = (selectedSizes, selectedDriver, selectedBodyTypes) => {
  const karts = [];

  selectedSizes.forEach((size) => {
    const driverGroups = DRIVERS_BY_SIZE[size];

    driverGroups.forEach((driverGroup) => {
      const filteredDrivers = filterDrivers(driverGroup, selectedDriver);
      if (!filteredDrivers.length) { return; }

      BODIES.forEach((bodyGroup) => {
        const filteredBodies = filterBodies(bodyGroup, selectedBodyTypes);
        if (!filteredBodies.length) { return; }

        TIRES.forEach((tire) => {
          GLIDERS.forEach((glider) => {
            const kart = buildKart(size, driverGroup, bodyGroup, tire, glider, filteredDrivers, filteredBodies);
            karts.push(kart);
          });
        });
      });
    });
  });

  return karts;
};

const filterDrivers = (driverGroup, selectedDriver) => {
  const driverNames = driverGroup[0];
  if (!selectedDriver) { return driverNames; }
  return driverNames.filter((driverName) => driverName === selectedDriver.name);
};

const filterBodies = (bodyGroup, selectedBodyTypes) => {
  if (!selectedBodyTypes.length) { return []; }

  const bodies = bodyGroup[0];

  return bodies.filter((body) => {
    const type = getBodyType(body);
    return selectedBodyTypes.includes(type);
  });
};

const getBodyType = (body) => {
  const types = Object.keys(BODIES_BY_TYPE);
  return types.find((t) => BODIES_BY_TYPE[t].includes(body));
};

const buildKart = (size, driverGroup, bodyGroup, tire, glider, filteredDrivers, filteredBodies) => {
  const kart = {
    drivers: filteredDrivers,
    bodies: filteredBodies,
    tires: tire[0],
    gliders: glider[0],
    size,
    stats: []
  };

  STATISTICS.forEach((_, index) => {
    const stat = calculateStatistic(index + 1, driverGroup, bodyGroup, tire, glider);
    kart.stats.push(stat);
  });

  return kart;
};

const calculateStatistic = (index, driverGroup, bodyGroup, tire, glider) => {
  const sum = driverGroup[index] + bodyGroup[index] + tire[index] + glider[index];
  return (sum + 3) / 4;
};
